import { useState } from 'react'
import { useLocation } from 'react-router-dom'

const Input = ({ width, height }) => {
  const [value, setValue] = useState("")

  const location = useLocation()

  const conditionalRoutesHeaderSearch = ['/communities', '/explore'].includes(location.pathname)

  return (
    <div className={`mt-8 md:mt-0 w-full ${conditionalRoutesHeaderSearch ? 'block' : 'hidden'}`}>

      <div className={`relative ${width}`}>
        <input type="text" placeholder="Search" className={`${width} ${height} bg-gray-50 text-darkGrey rounded-3xl border-2 border-solid border-darkGrey pl-12 outline-none`} value={value} onChange={(e) => setValue(e.target.value)} />
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search text-slate-300 absolute top-4 left-4" viewBox="0 0 16 16">
          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
        </svg>
      </div>
    </div>
  )
}

export default Input